import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { RiArrowLeftSLine, RiAddLine, RiScanLine, RiMenuLine } from 'react-icons/ri';
import '../styles/AddCustomToken.css';

const AddCustomToken = () => {
  const navigate = useNavigate();
  const [tokenAddress, setTokenAddress] = useState('');
  const [isAddressEntered, setIsAddressEntered] = useState(false);

  const handleAddressChange = (e) => {
    const value = e.target.value;
    setTokenAddress(value);
    setIsAddressEntered(value.length > 0);
  };

  const handleImport = () => {
    // Implement token import
    navigate('/custom-tokens');
  };

  return (
    <div className="add-token-page">
      <header className="page-header">
        <button className="back-button" onClick={() => navigate('/custom-tokens')}>
          <RiArrowLeftSLine />
        </button>
        <h1>Add custom tokens</h1>
        <button className="add-button">
          <RiAddLine />
        </button>
      </header>

      <div className="token-form">
        <div className="form-group">
          <label>Token address</label>
          <div className="address-input-container">
            <input
              type="text"
              value={tokenAddress}
              onChange={handleAddressChange}
              placeholder="0x..."
              className="address-input"
            />
            <div className="input-actions">
              <button className="action-button">
                <RiScanLine />
              </button>
              <button className="action-button">
                <RiMenuLine />
              </button>
            </div>
          </div>
        </div>

        <button 
          className={`import-button ${!isAddressEntered ? 'disabled' : ''}`}
          onClick={handleImport}
          disabled={!isAddressEntered}
        >
          Import token
        </button>
      </div>
    </div>
  );
};

export default AddCustomToken;
